// Ambiente de homologacao (build "homologation").
//
// A SPA e a API ficam na MESMA origem, e o proxy do ambiente roteia:
//   /portal/**        -> SPA
//   /portal/api/**    -> backend (sem o /portal)
//   /portal/securiy/**-> backend (sem o /portal)
//
// Por isso as URLs sao RELATIVAS: funcionam em qualquer host/dominio
// (qa.portal.eurofarma.avalara-solucoes.cloud hoje, outro amanha) sem rebuild
// - e evitam que o ambiente novo chame a API do servidor antigo.
export const environment = {
  production: false,
  basicPass: 'Basic YWRtaW46SGFpbmVAMTA=',
  backendUrl: '/portal/api',
  auth: '/portal',
};
